import { XMarkIcon } from '@heroicons/react/16/solid';
import { Button, Modal } from 'react-daisyui';
import { useTeamContext } from '../../Team.context';
import { Trans, useTranslation } from 'react-i18next';

export default function UserCreatedConfirmationV2() {
  const {
    toggleUserCreatedModalV2,
    setToggleUserCreatedModalV2,
    addedUserName,
    setAddedUserName,
  } = useTeamContext();
  const { t } = useTranslation('settings/team');

  return (
    <Modal
      open={toggleUserCreatedModalV2}
      className="UserCreatedModal"
      backdrop={true}
      responsive={true}
    >
      <Modal.Header className="UserCreatedModal__Header">
        <div className="flex flex-row justify-end w-full">
          <Button
            color="ghost"
            size="sm"
            shape="square"
            onClick={() => {
              setToggleUserCreatedModalV2(false);
              setAddedUserName(null);
            }}
          >
            <XMarkIcon className="UserCreatedModal__CloseIcon" />
          </Button>
        </div>
      </Modal.Header>
      <Modal.Body className="grid justify-items-center">
        <div className="text-8xl text-center">🎉</div>
        <h1 className="text-xl text-center">
          {t('page.userAddedModal.title')}
        </h1>
        <p className="text-center text-sm text-gray-500 mt-4">
          <Trans
            i18nKey="settings/team:page.userAddedModal.text"
            values={{
              name: addedUserName || 'the user',
            }}
            components={{
              b: <b />,
            }}
          />
        </p>
      </Modal.Body>
      <Modal.Actions className="justify-center">
        <Button
          color="primary"
          size="sm"
          onClick={() => {
            setToggleUserCreatedModalV2(false);
            setAddedUserName(null);
          }}
        >
          {t('page.userAddedModal.button')}
        </Button>
      </Modal.Actions>
    </Modal>
  );
}
